export class HoverSliderManager {
  constructor({ elem }) {
    this.elem = elem;
    this.elem.hoverSliderManagerInstance = this;

    this.images = [];
    try {
      const attrSlider = this.elem.dataset.hoverSlider;
      let rawImages = '';
      if (attrSlider && attrSlider.trim().startsWith('[')) {
        rawImages = attrSlider;
      } else {
        rawImages = this.elem.dataset.images || '[]';
      }
      this.images = JSON.parse(rawImages);
    } catch (e) {
      this.images = [];
    }

    this.imgEl = this.elem.querySelector('img');
    this.current = 0;

    this.init();
  }

  init() {
    this.initHover();
  }

  initHover() {
    if (this.images.length > 1 && this.imgEl) {
      this.elem.style.position = 'relative';

      /* Накладываем прозрачные секторы поверх картинки */
      this.overlay = document.createElement('div');
      this.overlay.style.cssText = 'position:absolute;inset:0;display:flex;z-index:2;';

      this.images.forEach((src, i) => {
        const sector = document.createElement('div');
        sector.style.cssText = 'flex:1;cursor:pointer;';
        sector.addEventListener('mouseenter', () => this.showImage(i));
        this.overlay.appendChild(sector);
      });

      this.elem.appendChild(this.overlay);

      /* Индикатор-точки под картинкой */
      this.dots = document.createElement('div');
      this.dots.className = 'hover-slider__dots product-card__dots';
      this.images.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'hover-slider__dot product-card__dot' + (i === 0 ? ' active' : '');
        this.dots.appendChild(dot);
      });
      this.elem.after(this.dots);

      /* При уходе мышки — возврат на первое */
      this.elem.addEventListener('mouseleave', () => this.showImage(0));
    }
  }

  showImage(index) {
    if (index === this.current) return;
    this.current = index;
    const newSrc = this.images[index];

    /* Обновление точек */
    if (this.dots) {
      this.dots.querySelectorAll('.hover-slider__dot, .product-card__dot').forEach((d, j) => {
        d.classList.toggle('active', j === index);
      });
    }

    if (!this.imgEl || !newSrc) return;

    // Сбрасываем старую загрузку/временный элемент
    if (this.tempImg) {
      this.tempImg.remove();
      this.tempImg = null;
    }

    // Создаем временную картинку (копия оригинальной со всеми её классами и инлайновыми стилями)
    const tempImg = this.imgEl.cloneNode(false);
    this.tempImg = tempImg;

    tempImg.removeAttribute('id');

    // Получаем все вычисленные стили оригинального изображения для максимальной универсальности
    const computed = window.getComputedStyle(this.imgEl);
    const stylesToCopy = [
      'objectFit', 'objectPosition', 'borderRadius', 'transform', 
      'transformOrigin', 'filter', 'clipPath', 'boxSizing',
      'border', 'padding', 'margin', 'verticalAlign', 'display',
      'aspectRatio'
    ];
    stylesToCopy.forEach(prop => {
      if (computed[prop]) {
        tempImg.style[prop] = computed[prop];
      }
    });

    // Настраиваем абсолютное позиционирование поверх основной картинки
    tempImg.style.position = 'absolute';
    tempImg.style.left = '0';
    tempImg.style.width = '100%';
    tempImg.style.zIndex = '1';
    tempImg.style.pointerEvents = 'none';

    // Временно делаем невидимой, пока грузится
    tempImg.style.opacity = '0';
    tempImg.style.transition = 'opacity 0.12s ease-in-out';

    tempImg.onload = () => {
      // Проверка на актуальность загрузки (пользователь мог уже перевести мышку дальше)
      if (this.tempImg !== tempImg) {
        tempImg.remove();
        return;
      }

      // 1. Показываем ее поверх
      tempImg.style.opacity = '1';

      // 2. Ждем окончания анимации появления и меняем основную
      setTimeout(() => {
        if (this.tempImg !== tempImg) {
          tempImg.remove();
          return;
        }

        // Меняем основную картинку на новую (она уже загружена в куки/кэш)
        this.imgEl.src = newSrc;

        // 3. Даём микропаузу браузеру на отрисовку основы и убираем временный элемент
        setTimeout(() => {
          if (this.tempImg === tempImg) {
            tempImg.remove();
            this.tempImg = null;
          }
        }, 40000);
      }, 120);
    };

    tempImg.onerror = () => {
      if (this.tempImg === tempImg) {
        this.tempImg = null;
      }
      tempImg.remove();
    };

    // Запускаем предзагрузку
    tempImg.src = newSrc;
    this.imgEl.after(tempImg);
  }
}
